import {
  PRODUCTS_SEARCH_REQUESTED,
  PRODUCTS_SEARCH_SUCCESS,
  PRODUCTS_SEARCH_FAILURE,
  PRODUCTS_SEARCH_RESET,
} from '../types';

const INITIAL_STATE = {
  searchedProducts: null,
  nextCursor: null,
  lastPage: false,
  isSearching: false,
  errors: null
};

const products = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case PRODUCTS_SEARCH_REQUESTED:
      return Object.assign({}, state, {
        isSearching: true,
        errors: null
      });

    case PRODUCTS_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        searchedProducts: action.payload.products || [],
        nextCursor: action.payload.next_cursor || null,
        lastPage: action.payload.last_page || false,
        isSearching: false,
        errors: null
      });

    case PRODUCTS_SEARCH_FAILURE:
      return Object.assign({}, state, {
        searchedProducts: [],
        isSearching: false,
        errors: 'The product search failed. Check your connection and try again.'
      });

    case PRODUCTS_SEARCH_RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default products;
